import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import avatar from './avatar.svg';
export default function OrderItem(props) {
  const { channels, cost } = props;

  return (
    <Grid container mt={2} spacing={2}>
      <Grid item xs={3} sm={3} sx={{ display: 'flex', alignItems: 'center' }}>
        <img
          src={avatar}
          srcSet={avatar}
          alt={'Avatar'}
          loading='lazy'
          width='100%'
        />
      </Grid>
      <Grid item xs={9} sm={9}>
        <Typography mt={1} sx={{ fontSize: '14px', fontWeight: 400 }}>
          Deepgram Asterisk Integration
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography
            sx={{ fontSize: '13px', fontWeight: 400 }}
          >{`Channels: ${channels}`}</Typography>
          <Typography
            sx={{ fontSize: '13px', fontWeight: 700 }}
          >{`$${cost}`}</Typography>
        </Box>
      </Grid>
    </Grid>
  );
}
